import { SxProps, Theme } from '@mui/material';
import type { ParticipantPillKind } from './participant-pill';

export const participantPillIconSx = (kind: ParticipantPillKind): SxProps<Theme> => ({
  color: (theme) => {
    const { sys } = theme.palette.custom.OV;
    if (kind === 'agent') return sys.secondary;
    if (kind === 'rsm') return sys.primary;
    if (kind === 'client') return theme.palette.warning.main;
    return sys.onSurfaceVariant;
  },
});

export const participantMenuItemSx: SxProps<Theme> = {
  px: 1,
  py: 0.25,
  '&:hover': { backgroundColor: 'transparent' },
  '&.Mui-focusVisible': { backgroundColor: 'transparent' },
  '&:hover .participant-menu-item-content, &.Mui-focusVisible .participant-menu-item-content':
    {
      backgroundColor: (theme) => theme.palette.custom.OV.sys.surfaceContainerHigh,
    },
};

export const participantMenuItemContentSx: SxProps<Theme> = {
  gap: 'inherit',
  width: 'fit-content',
  padding: '0.25rem 0.5rem',
  borderRadius: '0.375rem',
};

export const participantMenuHelpTextSx: SxProps<Theme> = {
  display: 'block',
  px: 2,
  pt: 1,
  pb: 0.5,
  maxWidth: '14.75rem',
  lineHeight: 1.45,
  color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
};
